import { t } from 'state/intl/translations';

import { getDescriptionDetailTextType } from './types';

export const getDescriptionDetailText: getDescriptionDetailTextType = ({ points }) => {
  return t('numberOfCrowns', { crowns: points });
};
